import { decryptData, encryptData } from "../controllers/encryptionUtils";
import instance from "./apiInstance";

const API = async (config = { url: "", method: "", headers: {}, params: {}, data: {} }) => {
  try {
    const excludedPaths = ["/fileupload", "/upload"];

    if (config?.data && !excludedPaths.some((path) => config.url.includes(path))) {
      config.data = encryptData(config.data);
    }
    const response = await instance({
      url: config.url,
      method: config.method,
      headers: {
        "Content-Type":
          config.url.includes("/fileupload/fileUpload") || config.url.includes("/fileupload/upload")
            ? "multipart/form-data"
            : "application/json",
        ...config.headers,
      },
      params: config.params,
      data: config.data,
    });
    return {
      data:
        process.env.REACT_APP_ENVIRONMENT === "PROD" ? decryptData(response.data) : response.data,
      status: response.status,
      headers: { ...response.headers },
    };
  } catch (error) {
    return Promise.reject(error);
  }
};

export default API;
